import { LOADED_PAGE } from "../actions/checkoutStore";
import Shipping from "../components/Shipping";

export default function GoogleEventManager(eventData, store) {
  if (!store.checkoutStore || !window.gtag || eventData.type != LOADED_PAGE)
    return;

  const { analytics_data } = store.checkoutStore;

  switch (eventData.payload.page) {
    case "checkout":
      emitInitiateCheckout(analytics_data);
      break;
    case "shipping":
      emitShippingCheckout(analytics_data);
      break;
    case "payment":
      emitPaymentCheckout(analytics_data);
      break;
    // case "success":
    //   emitSuccessCheckout(analytics_data);
    //   break;
  }

  return;
}

function emitInitiateCheckout(tagData) {
  window.gtag("event", "begin_checkout", {
    currency: tagData.order.currency,
    items: tagData.order_items,
    value: tagData.order.total || 0,
  });
}

function emitShippingCheckout(tagData) {
  window.gtag("event", "add_shipping_info", {
    currency: tagData.order.currency,
    items: tagData.order_items,
    value: tagData.order.total || 0,
  });
}

function emitPaymentCheckout(tagData) {
  window.gtag("event", "add_payment_info", {
    currency: tagData.order.currency,
    items: tagData.order_items,
    value: tagData.order.total || 0,
  });
}

// function emitSuccessCheckout(tagData) {
//   window.gtag("event", "purchase", {
//     currency: tagData.order.currency,
//     items: tagData.order_items,
//     value: tagData.order.total || 0,
//     transaction_id: tagData.order.showid,
//     Shipping: tagData.order.shipping || 0,
//     tax: tagData.order.tax || 0,
//   });
// }
